const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchListFiles({ commit }, payload) {
    try {
      let url;
      if (!payload.classSectionId) {
        url = `api/module/classroom/${payload.classId}/course/${payload.courseId}/file-list?search=${payload.search}`;
      } else {
        url = `api/module/class-section/${payload.classSectionId}/file-list?search=${payload.search}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, payload) {
    try {
      let url;
      if (!payload.classSectionId) {
        url = `api/module/classroom/${payload.classroomId}/course/${payload.courseId}?search=${payload.search}`;
      } else {
        url = `api/module/class-section/${payload.classSectionId}?search=${payload.search ? payload.search : ''}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/module/${payload}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  save({ commit }, payload) {
    let url;
    if (!payload.classSectionId) {
      url = `/api/module/classroom/${payload.classId}/course/${payload.courseId}`;
    } else {
      url = `/api/module/class-section/${payload.classSectionId}`;
    }
    return window.axios.post(`${url}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  changeOrder({ commit }, payload) {
    let url;
    if (!payload.classSectionId) {
      url = `/api/module/classroom/${payload.classroomId}/course/${payload.courseId}`;
    } else {
      url = `/api/module/class-section/${payload.classSectionId}`;
    }
    return window.axios.put(`${url}`, payload.datas);
  },
  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    return window.axios.put(`/api/module/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/module/${payload}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
